import { Flex } from '@chakra-ui/react';
import {
  faArrowLeft,
  faBuilding,
  faChartLine,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { UserRole } from '@snap-types/models/enums';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import { ModalLayout } from '@ui/components/layout/ModalLayout';
import { Navigation } from '@ui/components/layout/Navigation';
import { WithPermission } from '@ui/components/Permission';
import { Router } from '@ui/config/routes';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export function AdminLayout() {
  return (
    <>
      <ModalLayout />

      <Flex direction="row">
        <Navigation.Menu>
          <Navigation.Item
            label="Back to SNAP"
            path={Router.path(Router.routes.root)}
            icon={faArrowLeft}
          />

          <Navigation.Divider />

          <Navigation.Item
            label="Sites"
            path={Router.path(Router.routes.adminSites)}
            icon={faBuilding}
          />

          <WithPermission minimumRole={UserRole.SUPERADMIN}>
            <Navigation.Item
              label="Users"
              path={Router.path(Router.routes.adminUsers)}
              icon={faUsers}
            />
          </WithPermission>

          <Navigation.Divider />

          <WithPermission minimumRole={UserRole.SUPERADMIN}>
            <Navigation.Item
              label="Metrics"
              path={Router.path(Router.routes.metrics)}
              icon={faChartLine}
            />
          </WithPermission>

          <Navigation.ResourceHubLink />
        </Navigation.Menu>

        {/* @NOTE(shawk): ensure <NavigationBar /> stays visible
            while descendent lazy-loaded routes are loading */}
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Flex>
    </>
  );
}
